import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { AirExportJob } from '@/class/model/booking/AirExportJob'

export class TabHAWBPM extends AbstractViewManage {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.view = view
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  async fillView() {
    if (this.job) {
      if (!this.view.isEditing) { // 非编辑状态下直接加载数据即可
        this.view.form = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.HAWB, false)
        if (!this.view.form) {
          this.view.form = new AirCargoDoc().fillDefaultValue().getData()
        }
        if (this.view.form.uuid) {
          this.form.otherCharge = ''
          await new AirCargoDoc(this.view.form).getOtherCharge()
        }
      } else {
        this.view.form = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.HAWB, true)
        if (this.view.form.uuid) {
          await new AirCargoDoc(this.view.form).getOtherCharge()
        } else { // 新增的cargoDoc, 要加入到Job中去
          if (!this.job.airCargoDoc || this.job.airCargoDoc.length === 0) {
            this.job.airCargoDoc = []
          }
          let hasHawb = false
          for (const item of this.job.airCargoDoc) {
            if (item.docType === CargoDocConsts.HAWB) {
              hasHawb = true
              break
            }
          }
          if (!hasHawb) {
            this.job.airCargoDoc.push(this.view.form)
          }
        }
      }
    }
    this.view.$refs.hawb.fillView()
  }
  executeTask() {
  }
}
